/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown> }} Onboarding_Progress_CountInputs */

const en_us2_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} of ${i?.total}`)
};

const pt_br2_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} de ${i?.total}`)
};

const es_419_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} de ${i?.total}`)
};

const pt_pt2_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} de ${i?.total}`)
};

const fr_fr2_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} sur ${i?.total}`)
};

const de_de2_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} von ${i?.total}`)
};

const it_it2_onboarding_progress_count = /** @type {(inputs: Onboarding_Progress_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.index} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{index} of {total}" |
*
* @param {Onboarding_Progress_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_progress_count = /** @type {((inputs: Onboarding_Progress_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Progress_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_progress_count(inputs)
	if (locale === "es-419") return es_419_onboarding_progress_count(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_progress_count(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_progress_count(inputs)
	if (locale === "de-DE") return de_de2_onboarding_progress_count(inputs)
	if (locale === "it-IT") return it_it2_onboarding_progress_count(inputs)
	return en_us2_onboarding_progress_count(inputs)
});
export { onboarding_progress_count as "onboarding.progress_count" }